<template>
    <div class="timeline-area pt-4 pb-4">
        <div class="years-container" :class="{'partial' : partial}"
             :style="'--partialHeight : ' + minHeight + 'px; --fullHeight : ' + maxHeight + 'px;'">
            <div v-for="(item, index) in orderedItems" class="year row no-gutters"
                 :class="{'left-year' : index % 2 !== 0, 'right-year' : index % 2 === 0}">
                <article class="col-6 pr-5 text-right">
                    <h5 v-text="index % 2 !== 0 ? item.year : ''"></h5>
                    <span v-html="index % 2 !== 0 ? item.description : ''"></span>
                </article>
                <article class="col-6 pl-5 text-left">
                    <h5 v-text="index % 2 === 0 ? item.year : ''"></h5>
                    <span v-html="index % 2 === 0 ? item.description : ''"></span>
                </article>
            </div>
        </div>
        <span class="show-years mt-5" v-text="buttonText" @click="toggleTimeline()" v-if="partial"></span>
    </div>
</template>

<script>
    export default {
        props: ['items', 'opened'],
        data: () => {
            return {
                partial: true,
                minHeight: 0,
                maxHeight: 1000,
            }
        },
        computed: {
            orderedItems: function () {
                return Object.values(this.items)
                    .sort((a, b) => b.year - a.year);
            },
            buttonText: function () {
                return this.partial ? 'Ver anos anteriores' : 'Ocultar anos anteriores';
            }
        },
        methods: {
            toggleTimeline() {
                this.partial = !this.partial;
            },

            calculateHeight() {
                this.minHeight = 0;
                this.maxHeight = 0;

                $(this.$el).find('.year').each((index, element) => {
                    if (index < 3) {
                        this.minHeight += $(element).outerHeight();
                    }
                    this.maxHeight += $(element).outerHeight();
                });
            }
        },
        mounted() {
            this.partial = !this.opened;
            this.calculateHeight();
        }
    }
</script>
